import { z } from 'zod'

import type { Language } from '@nxt-insurance/constants'

import { termLifeSchema } from '@flows/configs/de/termLife/types'
import type { generateGetFlowValueFunctions } from '@flows/insurance/utils'

export interface TermLifeStepParams {
  getCurrentLanguage: () => Language
  helperFunctions: ReturnType<typeof generateGetFlowValueFunctions>
  platform: 'web' | 'native'
  environment: string
}

export const whoBenefitsSchema = z.object({
  products: z.object({
    mga_term_life_insurance_de: z.object({
      configuration_parameters: termLifeSchema.pick({
        who_benefits: true,
      }),
    }),
  }),
})

export const loanSchema = z.object({
  products: z.object({
    mga_term_life_insurance_de: z.object({
      configuration_parameters: termLifeSchema.pick({
        loan: true,
      }),
    }),
  }),
})

export const insuredSumSchema = z.object({
  products: z.object({
    mga_term_life_insurance_de: z.object({
      configuration_parameters: termLifeSchema.pick({
        insured_sum: true,
      }),
    }),
  }),
})

export const employmentStatusSchema = z.object({
  products: z.object({
    mga_term_life_insurance_de: z.object({
      configuration_parameters: termLifeSchema.pick({
        employment_status: true,
      }),
    }),
  }),
})

export const yearlyIncomeSchema = z.object({
  products: z.object({
    mga_term_life_insurance_de: z.object({
      configuration_parameters: termLifeSchema.pick({
        income: true,
      }),
    }),
  }),
})

export const successSchema = z.object({})
